
// SVG Icon: show-less
export default { id: "terriajs-show-less" };
export const id = "terriajs-show-less";
export const name = "show-less";
